var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11H8.25C8.6297 11 8.94349 11.2822 8.99315 11.6482L9 11.75V16.25C9 16.6642 8.66421 17 8.25 17C7.8703 17 7.55651 16.7178 7.50685 16.3518L7.5 16.25V13.56L3.03033 18.0303C2.73744 18.3232 2.26256 18.3232 1.96967 18.0303C1.7034 17.7641 1.6792 17.3474 1.89705 17.0538L1.96967 16.9697L6.438 12.5H3.75C3.3703 12.5 3.05651 12.2178 3.00685 11.8518L3 11.75C3 11.3703 3.28215 11.0565 3.64823 11.0068L3.75 11H8.25H3.75ZM18.0303 1.96967C18.2966 2.23594 18.3208 2.6526 18.1029 2.94621L18.0303 3.03033L13.06 8H16.25C16.6297 8 16.9435 8.28215 16.9932 8.64823L17 8.75C17 9.1297 16.7178 9.44349 16.3518 9.49315L16.25 9.5H11.25C10.8703 9.5 10.5565 9.21785 10.5068 8.85177L10.5 8.75V3.75C10.5 3.33579 10.8358 3 11.25 3C11.6297 3 11.9435 3.28215 11.9932 3.64823L12 3.75V6.938L16.9697 1.96967C17.2626 1.67678 17.7374 1.67678 18.0303 1.96967Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.5691f118b7a90e379975625138d55a0a.svg";
export { ForwardRef as ReactComponent };